import styled from "styled-components";

const ViewToolsContainer = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 100;
  width: 285px;
`;

export default ViewToolsContainer;
